import {$data} from '../helpers/data';
import Component from '../classes/Component';
import Toastify from 'toastify-js'
import { $dom } from '../helpers/dom';
import { $events } from '../helpers/events';
import { generateId } from '../helpers/_utilities';

const {merge} = $data;

export default function(settings = {}) {

  const defaults = {
    duration: 3000,
    newWindow: true,
    close: false,
    gravity: 'top',
    position: 'left',
    stopOnFocus: true,
    escapeMarkup: false
  };

  const
    pluginOptions = merge(defaults, settings),
    rootClassName = 'toastify',
    closeIconClassName = 'toastify-icon-close',
    icons = {
      success: 'check',
      warning: 'exclamation',
      info: 'info',
      danger: 'warning'
    }
  ;

  const $Page = this;

  return new Component({
    name: 'toast',
    requiredTargets: 'STAND_ALONE',
    onInit() {
      this.toasts = [];

      const createIcon = (name, className = '') => {
        return `<svg class="svg-icon${className ? ` ${className}` : ''}">
          <use xlink:href="${$Page.assetsPath}/sprite.svg#${name}"></use>
        </svg>`;
      };

      this.handleClose = (e) => {
        const currentToastRoot = e.target.closest(`.${rootClassName}`);
        const currentToastId = currentToastRoot.id;

        if (currentToastId) {
          this.toasts
            .find(t => t.id === currentToastId)
            ?.toast
            ?.hideToast()
        }
      };

      this.show = function (text = '', status = 'info') {
        const contentEl = $dom.createElement('span', {class: `${rootClassName}-content`});
        const textEl = $dom.createElement('span', {class: `${rootClassName}-text text-clamp text-clamp-five`});
        textEl.innerHTML = text;

        const statusIcon = createIcon(icons[status], `${rootClassName}-icon ${rootClassName}-icon-status`);
        const closeIcon = createIcon('close', `${rootClassName}-icon ${closeIconClassName}`);

        contentEl.innerHTML = statusIcon + textEl.outerHTML + closeIcon;

        const id = generateId(false);
        const toast = Toastify({
          className: 'status-'+status,
          node: contentEl,
          ...pluginOptions
        });

        this.toasts.push({toast, id});
        
        toast.showToast();
        toast.toastElement.id = id;
      };


      $events.delegate
        .on('click', `.${rootClassName} .${closeIconClassName}`, this.handleClose)
    },
    onDestroy() {
      $events.delegate
        .off('click', `.${rootClassName} .${closeIconClassName}`, this.handleClose)
    }
  })
}
